// Starts from here
// admins
export const FETCH_ADMINS_REQUEST = 'FETCH_ADMINS_REQUEST';
export const FETCH_ADMINS_SUCCESS = 'FETCH_ADMINS_SUCCESS';
export const FETCH_ADMINS_FAILURE = 'FETCH_ADMINS_FAILURE';
export const FETCH_ADMIN_BY_ID_REQUEST = 'FETCH_ADMIN_BY_ID_REQUEST';
export const FETCH_ADMIN_BY_ID_SUCCESS = 'FETCH_ADMIN_BY_ID_SUCCESS';
export const FETCH_ADMIN_BY_ID_FAILURE = 'FETCH_ADMIN_BY_ID_FAILURE';
export const FETCH_SELF_REQUEST = 'FETCH_SELF_REQUEST';
export const FETCH_SELF_SUCCESS = 'FETCH_SELF_SUCCESS';
export const FETCH_SELF_FAILURE = 'FETCH_SELF_FAILURE';
export const DELETE_ADMIN_BY_ID_SUCCESS = 'DELETE_ADMIN_BY_ID_SUCCESS';
export const DELETE_ADMIN_BY_ID_FAILURE = 'DELETE_ADMIN_BY_ID_FAILURE';

// users
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';
export const FETCH_USERS_BLANK = 'FETCH_USERS_BLANK';
export const FETCH_USER_BY_ID_REQUEST = 'FETCH_USER_BY_ID_REQUEST';
export const FETCH_USER_BY_ID_SUCCESS = 'FETCH_USER_BY_ID_SUCCESS';
export const FETCH_USER_BY_ID_FAILURE = 'FETCH_USER_BY_ID_FAILURE';

// algos universal
export const FETCH_ALGOS_UNIVERSAL_REQUEST = 'FETCH_ALGOS_UNIVERSAL_REQUEST';
export const FETCH_ALGOS_UNIVERSAL_SUCCESS = 'FETCH_ALGOS_UNIVERSAL_SUCCESS';
export const FETCH_ALGOS_UNIVERSAL_FAILURE = 'FETCH_ALGOS_UNIVERSAL_FAILURE';
export const FETCH_ALGO_UNIVERSAL_BY_ID_REQUEST =
  'FETCH_ALGO_UNIVERSAL_BY_ID_REQUEST';
export const FETCH_ALGO_UNIVERSAL_BY_ID_SUCCESS =
  'FETCH_ALGO_UNIVERSAL_BY_ID_SUCCESS';
export const FETCH_ALGO_UNIVERSAL_BY_ID_FAILURE =
  'FETCH_ALGO_UNIVERSAL_BY_ID_FAILURE';

// Order book
export const FETCH_ORDER_BOOK_REQUEST = 'FETCH_ORDER_BOOK_REQUEST';
export const FETCH_ORDER_BOOK_SUCCESS = 'FETCH_ORDER_BOOK_SUCCESS';
export const FETCH_ORDER_BOOK_FAILURE = 'FETCH_ORDER_BOOK_FAILURE';
export const CLEAR_ORDER_BOOK = 'CLEAR_ORDER_BOOK';

// algos
export const FETCH_ALGOS_REQUEST = 'FETCH_ALGOS_REQUEST';
export const FETCH_ALGOS_SUCCESS = 'FETCH_ALGOS_SUCCESS';
export const FETCH_ALGOS_FAILURE = 'FETCH_ALGOS_FAILURE';
export const FETCH_ALGO_BY_ID_REQUEST = 'FETCH_ALGO_BY_ID_REQUEST';
export const FETCH_ALGO_BY_ID_SUCCESS = 'FETCH_ALGO_BY_ID_SUCCESS';
export const FETCH_ALGO_BY_ID_FAILURE = 'FETCH_ALGO_BY_ID_FAILURE';
export const FETCH_ALGO_CONFIG_REQUEST = 'FETCH_ALGO_CONFIG_REQUEST';
export const FETCH_ALGO_CONFIG_SUCCESS = 'FETCH_ALGO_CONFIG_SUCCESS';
export const FETCH_ALGO_CONFIG_FAILURE = 'FETCH_ALGO_CONFIG_FAILURE';

// master contracts
export const FETCH_MASTER_CONTRACTS_REQUEST = 'FETCH_MASTER_CONTRACTS_REQUEST';
export const FETCH_MASTER_CONTRACTS_SUCCESS = 'FETCH_MASTER_CONTRACTS_SUCCESS';
export const FETCH_MASTER_CONTRACTS_FAILURE = 'FETCH_MASTER_CONTRACTS_FAILURE';

// health
export const FETCH_HEALTH_STATUS_REQUEST = 'FETCH_HEALTH_STATUS_REQUEST';
export const FETCH_HEALTH_STATUS_SUCCESS = 'FETCH_HEALTH_STATUS_SUCCESS';
export const FETCH_HEALTH_STATUS_FAILURE = 'FETCH_HEALTH_STATUS_FAILURE';

export const CHANGE_HEALTH_STATUS_PARAM = 'CHANGE_HEALTH_STATUS_PARAM';

// config
export const FETCH_CONFIG_REQUEST = 'FETCH_CONFIG_REQUEST';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_FAILURE = 'FETCH_CONFIG_FAILURE';
export const CONFIG_SET_ACTIVE_FEED_REQUEST = 'CONFIG_SET_ACTIVE_FEED_REQUEST';
export const CONFIG_SET_ACTIVE_FEED_SUCCESS = 'CONFIG_SET_ACTIVE_FEED_SUCCESS';
export const CONFIG_SET_ACTIVE_FEED_FAILURE = 'CONFIG_SET_ACTIVE_FEED_FAILURE';
export const CONFIG_UPDATE_REFERRAL_TYPE_FIELD =
  'CONFIG_UPDATE_REFERRAL_TYPE_FIELD';

// faq topics
export const FETCH_FAQ_TOPICS_REQUEST = 'FETCH_FAQ_TOPICS_REQUEST';
export const FETCH_FAQ_TOPICS_SUCCESS = 'FETCH_FAQ_TOPICS_SUCCESS';
export const FETCH_FAQ_TOPICS_FAILURE = 'FETCH_FAQ_TOPICS_FAILURE';
export const FETCH_FAQ_TOPIC_BY_ID_REQUEST = 'FETCH_FAQ_TOPIC_BY_ID_REQUEST';
export const FETCH_FAQ_TOPIC_BY_ID_SUCCESS = 'FETCH_FAQ_TOPIC_BY_ID_SUCCESS';
export const FETCH_FAQ_TOPIC_BY_ID_FAILURE = 'FETCH_FAQ_TOPIC_BY_ID_FAILURE';

// faqs
export const FETCH_FAQS_REQUEST = 'FETCH_FAQS_REQUEST';
export const FETCH_FAQS_SUCCESS = 'FETCH_FAQS_SUCCESS';
export const FETCH_FAQS_FAILURE = 'FETCH_FAQS_FAILURE';
export const FETCH_FAQ_BY_ID_REQUEST = 'FETCH_FAQ_BY_ID_REQUEST';
export const FETCH_FAQ_BY_ID_SUCCESS = 'FETCH_FAQ_BY_ID_SUCCESS';
export const FETCH_FAQ_BY_ID_FAILURE = 'FETCH_FAQ_BY_ID_FAILURE';

// payouts
export const FETCH_PAYOUTS_REQUEST = 'FETCH_PAYOUTS_REQUEST';
export const FETCH_PAYOUTS_SUCCESS = 'FETCH_PAYOUTS_SUCCESS';
export const FETCH_PAYOUTS_FAILURE = 'FETCH_PAYOUTS_FAILURE';

// Coupons
export const FETCH_COUPONS_REQUEST = 'FETCH_COUPONS_REQUEST';
export const FETCH_COUPONS_SUCCESS = 'FETCH_COUPONS_SUCCESS';
export const FETCH_COUPONS_FAILURE = 'FETCH_COUPONS_FAILURE';
export const FETCH_COUPON_BY_ID_REQUEST = 'FETCH_COUPON_BY_ID_REQUEST';
export const FETCH_COUPON_BY_ID_SUCCESS = 'FETCH_COUPON_BY_ID_SUCCESS';
export const FETCH_COUPON_BY_ID_FAILURE = 'FETCH_COUPON_BY_ID_FAILURE';
export const DELETE_COUPON_BY_ID_SUCCESS = 'DELETE_COUPON_BY_ID_SUCCESS';
export const DELETE_COUPON_BY_ID_FAILURE = 'DELETE_COUPON_BY_ID_FAILURE';
export const COUPON_SELECTED_CLEAR = 'COUPON_SELECTED_CLEAR';

// failed
export const GENERAL_FAILURE = 'GENERAL_FAILURE';
export const GENERAL_REQUEST = 'GENERAL_REQUEST';

// users credits
export const FETCH_USER_CREDITS_REQUEST = 'FETCH_USER_CREDITS_REQUEST';
export const FETCH_USER_CREDITS_SUCCESS = 'FETCH_USER_CREDITS_SUCCESS';
export const FETCH_USER_CREDITS_FAILURE = 'FETCH_USER_CREDITS_FAILURE';

// twitter post
export const TWITTER_POST_ADD_NEW = 'TWITTER_POST_ADD_NEW';
export const TWITTER_POST_SET_DATE = 'TWITTER_POST_SET_DATE';
export const TWITTER_POINT_TITLE_CHANGE = 'TWITTER_POINT_TITLE_CHANGE';
export const TWITTER_POINT_DESCRIPTION_CHANGE =
  'TWITTER_POINT_DESCRIPTION_CHANGE';
export const TWITTER_CLEAR_FORM = 'TWITTER_CLEAR_FORM';
export const TWITTER_POINT_DELETE = 'TWITTER_POINT_DELETE';
export const TWITTER_POST_TITLE_CHANGE = 'TWITTER_POST_TITLE_CHANGE';
export const TWITTER_POINTS_HEIGHT = 'TWITTER_POINTS_HEIGHT';

export const REPORT_CHANGE_START_DAY = 'REPORT_CHANGE_START_DAY';
export const REPORT_CHANGE_END_DAY = 'REPORT_CHANGE_END_DAY';
export const REPORT_SET_ERRORS = 'REPORT_SET_ERRORS';
export const REPORT_RESET = 'REPORT_RESET';
export const REPORT_SET_LOADING = 'REPORT_SET_LOADING';

// Instance
export const FETCH_INSTANCE_REQUEST = 'FETCH_INSTANCE_REQUEST';
export const FETCH_INSTANCE_SUCCESS = 'FETCH_INSTANCE_SUCCESS';
export const FETCH_INSTANCE_FAILURE = 'FETCH_INSTANCE_FAILURE';
export const UPDATE_INSTANCE_SUCCESS = 'UPDATE_INSTANCE_SUCCESS';

// Theme
export const THEME_TOGGLE = 'THEME_TOGGLE';

// jobs
export const FETCH_JOBS_LIST_REQUEST = 'FETCH_JOBS_LIST_REQUEST';
export const FETCH_JOBS_LIST_SUCCESS = 'FETCH_JOBS_LIST_SUCCESS';
export const FETCH_JOBS_LIST_FAILURE = 'FETCH_JOBS_LIST_FAILURE';
export const CHANGE_JOB_TYPE = 'CHANGE_JOB_TYPE';
export const CHANGE_JOB_INFO = 'CHANGE_JOB_INFO';
export const SET_JOB_SELECTED_ERRORS = 'SET_JOB_SELECTED_ERRORS';
export const CLEAR_JOB_SELECTED_ERRORS = 'CLEAR_JOB_SELECTED_ERRORS';
export const CLEAR_JOBS_DATA = 'CLEAR_JOBS_DATA';
export const ADD_A_JOB_REQUEST = 'ADD_A_JOB_REQUEST';
export const ADD_A_JOB_SUCCESS = 'ADD_A_JOB_SUCCESS';
export const ADD_A_JOB_FAILURE = 'ADD_A_JOB_FAILURE';
export const FETCH_JOB_BY_ID_SUCCESS = 'FETCH_JOB_BY_ID_SUCCESS';

// annoucements
export const FETCH_ANNOUNCEMENTS_REQUEST = 'FETCH_ANNOUNCEMENTS_REQUEST';
export const FETCH_ANNOUNCEMENTS_SUCCESS = 'FETCH_ANNOUNCEMENTS_SUCCESS';
export const FETCH_ANNOUNCEMENTS_FAILURE = 'FETCH_ANNOUNCEMENTS_FAILURE';
export const CHANGE_ANNOUNCEMENT_MESSAGE = 'CHANGE_ANNOUNCEMENT_MESSAGE';
export const CHANGE_ANNOUNCEMENT_INFO = 'CHANGE_ANNOUNCEMENT_INFO';
export const CHANGE_ANNOUNCEMENT_FILTER_PARAMS_INFO =
  'CHANGE_ANNOUNCEMENT_FILTER_PARAMS_INFO';
export const SET_ANNOUNCEMENT_SELECTED_ERRORS =
  'SET_ANNOUNCEMENT_SELECTED_ERRORS';
export const CLEAR_ANNOUNCEMENT_SELECTED_ERRORS =
  'CLEAR_ANNOUNCEMENT_SELECTED_ERRORS';
export const CLEAR_ANNOUNCEMENTS_DATA = 'CLEAR_ANNOUNCEMENTS_DATA';
export const CREATE_A_ANNOUNCEMENT_REQUEST = 'CREATE_A_ANNOUNCEMENT_REQUEST';
export const CREATE_A_ANNOUNCEMENT_FAILURE = 'CREATE_A_ANNOUNCEMENT_FAILURE';
export const CREATE_A_ANNOUNCEMENT_SUCCESS = 'CREATE_A_ANNOUNCEMENT_SUCCESS';
export const FETCH_ANNOUNCEMENT_BY_ID_REQUEST =
  'FETCH_ANNOUNCEMENT_BY_ID_REQUEST';
export const FETCH_ANNOUNCEMENT_BY_ID_SUCCESS =
  'FETCH_ANNOUNCEMENT_BY_ID_SUCCESS';
export const FETCH_ANNOUNCEMENT_BY_ID_FAILURE =
  'FETCH_ANNOUNCEMENT_BY_ID_FAILURE';
export const DELETE_ANNOUNCEMENT_BY_ID_REQUEST =
  'DELETE_ANNOUNCEMENT_BY_ID_REQUEST';
export const DELETE_ANNOUNCEMENT_BY_ID_SUCCESS =
  'DELETE_ANNOUNCEMENT_BY_ID_SUCCESS';
export const DELETE_ANNOUNCEMENT_BY_ID_FAILURE =
  'DELETE_ANNOUNCEMENT_BY_ID_FAILURE';
export const EDIT_ANNOUNCEMENT_BY_ID_REQUEST =
  'EDIT_ANNOUNCEMENT_BY_ID_REQUEST';
export const EDIT_ANNOUNCEMENT_BY_ID_SUCCESS =
  'EDIT_ANNOUNCEMENT_BY_ID_SUCCESS';
export const EDIT_ANNOUNCEMENT_BY_ID_FAILURE =
  'EDIT_ANNOUNCEMENT_BY_ID_FAILURE';

// Generative: meta component
export const FETCH_META_COMPONENT_REQUEST = 'FETCH_META_COMPONENT_REQUEST';
export const FETCH_META_COMPONENT_SUCCESS = 'FETCH_META_COMPONENT_SUCCESS';
export const FETCH_META_COMPONENT_FAILURE = 'FETCH_META_COMPONENT_FAILURE';

// subscription history
export const FETCH_SUBSCRIPTION_HISTORY_REQUEST =
  'FETCH_SUBSCRIPTION_HISTORY_REQUEST';
export const FETCH_SUBSCRIPTION_HISTORY_SUCCESS =
  'FETCH_SUBSCRIPTION_HISTORY_SUCCESS';
export const FETCH_SUBSCRIPTION_HISTORY_FAILURE =
  'FETCH_SUBSCRIPTION_HISTORY_FAILURE';

// Sign up pages
export const FETCH_SIGNUP_PAGES_REQUEST = 'FETCH_SIGNUP_PAGES_REQUEST';
export const FETCH_SIGNUP_PAGES_SUCCESS = 'FETCH_SIGNUP_PAGES_SUCCESS';
export const FETCH_SIGNUP_PAGES_FAILURE = 'FETCH_SIGNUP_PAGES_FAILURE';
export const FETCH_SIGNUP_PAGE_BY_ID_REQUEST =
  'FETCH_SIGNUP_PAGE_BY_ID_REQUEST';
export const FETCH_SIGNUP_PAGE_BY_ID_SUCCESS =
  'FETCH_SIGNUP_PAGE_BY_ID_SUCCESS';
export const FETCH_SIGNUP_PAGE_BY_ID_FAILURE =
  'FETCH_SIGNUP_PAGE_BY_ID_FAILURE';
export const DELETE_SIGNUP_PAGE_BY_ID_SUCCESS =
  'DELETE_SIGNUP_PAGE_BY_ID_SUCCESS';
export const DELETE_SIGNUP_PAGE_BY_ID_FAILURE =
  'DELETE_SIGNUP_PAGE_BY_ID_FAILURE';
export const SIGNUP_PAGE_SELECTED_CLEAR = 'SIGNUP_PAGE_SELECTED_CLEAR';

// Referred Users
export const FETCH_REFERRED_USERS_REQUEST = 'FETCH_REFERRED_USERS_REQUEST';
export const FETCH_REFERRED_USERS_SUCCESS = 'FETCH_REFERRED_USERS_SUCCESS';
export const FETCH_REFERRED_USERS_FAILURE = 'FETCH_REFERRED_USERS_FAILURE';

// Notification Monitoring
export const FETCH_NOTIFICATION_MONITORING_REQUEST =
  'FETCH_NOTIFICATION_MONITORING_REQUEST';
export const FETCH_NOTIFICATION_MONITORING_SUCCESS =
  'FETCH_NOTIFICATION_MONITORING_SUCCESS';
export const FETCH_NOTIFICATION_MONITORING_FAILURE =
  'FETCH_NOTIFICATION_MONITORING_FAILURE';
export const DELETE_NOTIFICATION_MONITORING_BY_ID_SUCCESS =
  'DELETE_NOTIFICATION_MONITORING_BY_ID_SUCCESS';
export const DELETE_NOTIFICATION_MONITORING_BY_ID_FAILURE =
  'DELETE_NOTIFICATION_MONITORING_BY_ID_FAILURE';

// GENERATE_LOGIN_LINK
export const FETCH_GENERATE_LOGIN_LINK_REQUEST =
  'FETCH_GENERATE_LOGIN_LINK_REQUEST';
export const FETCH_GENERATE_LOGIN_LINK_SUCCESS =
  'FETCH_GENERATE_LOGIN_LINK_SUCCESS';
export const FETCH_GENERATE_LOGIN_LINK_FAILURE =
  'FETCH_GENERATE_LOGIN_LINK_FAILURE';
export const FETCH_GENERATE_LOGIN_LINK_RESET =
  'FETCH_GENERATE_LOGIN_LINK_RESET';

// signals
export const FETCH_SIGNALS_REQUEST = 'FETCH_SIGNALS_REQUEST';
export const FETCH_SIGNALS_SUCCESS = 'FETCH_SIGNALS_SUCCESS';
export const FETCH_SIGNALS_FAILURE = 'FETCH_SIGNALS_FAILURE';

export const FETCH_SIGNAL_BY_ID_REQUEST = 'FETCH_SIGNAL_BY_ID_REQUEST';
export const FETCH_SIGNAL_BY_ID_SUCCESS = 'FETCH_SIGNAL_BY_ID_SUCCESS';
export const FETCH_SIGNAL_BY_ID_FAILURE = 'FETCH_SIGNAL_BY_ID_FAILURE';

export const SELECTED_ALERT_REQUEST = 'SELECTED_ALERT_REQUEST';
export const SELECTED_ALERT_CLEAR = 'SELECTED_ALERT_CLEAR';

// EXPIRY_DATES
export const FETCH_EXPIRY_DATES_REQUEST = 'FETCH_EXPIRY_DATES_REQUEST';
export const FETCH_EXPIRY_DATES_SUCCESS = 'FETCH_EXPIRY_DATES_SUCCESS';
export const FETCH_EXPIRY_DATES_FAILURE = 'FETCH_EXPIRY_DATES_FAILURE';
export const UPDATE_EXPIRY_DATE = 'UPDATE_EXPIRY_DATE';
export const FETCH_EXPIRY_DATES_RESET = 'FETCH_GENERATE_LOGIN_LINK_RESET';

// BROKER_SETTINGS
export const FETCH_BROKER_SETTINGS_REQUEST = 'FETCH_BROKER_SETTINGS_REQUEST';
export const FETCH_BROKER_SETTINGS_SUCCESS = 'FETCH_BROKER_SETTINGS_SUCCESS';
export const FETCH_BROKER_SETTINGS_FAILURE = 'FETCH_BROKER_SETTINGS_FAILURE';
export const FETCH_BROKER_SETTINGS_LOADING = 'FETCH_BROKER_SETTINGS_LOADING';
export const BROKER_SETTINGS_UPDATE_FIELD_VALUE =
  'BROKER_SETTINGS_UPDATE_FIELD_VALUE';
export const BROKER_SETTINGS_EDIT_FIELD = 'BROKER_SETTINGS_EDIT_FIELD';
export const FETCH_BROKER_SETTINGS_RESET = 'FETCH_GENERATE_LOGIN_LINK_RESET';
